import { configureStore } from '@reduxjs/toolkit';
import type { Action, ThunkAction } from '@reduxjs/toolkit';

import { appReducer } from '../features/app/app.slice';
import { tableReducer } from '../features/table/table.slice';
import { toastReducer } from '../features/toast/toast.slice';
import { drawerReducer } from '../features/drawer/drawer.slice';

export const store = configureStore({
  reducer: {
    app: appReducer,
    table: tableReducer,
    toast: toastReducer,
    drawer: drawerReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['table.websitesData'],
        ignoredActions: ['table/getWebsitesData/fulfilled'],
      },
    }),
  devTools: {
    trace: true,
    traceLimit: 10,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action
>;
